import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Megaphone, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, friendlyError } from "@/lib/api";

export function AnnouncementsTab() {
  const qc = useQueryClient();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const { data: items = [] } = useQuery({ queryKey: ["host-announcements"], queryFn: async () => (await api.get("/announcements")).data });
  const refresh = () => { qc.invalidateQueries({ queryKey: ["host-announcements"] }); qc.invalidateQueries({ queryKey: ["announcements"] }); };

  const post = async () => {
    if (!title.trim() || !message.trim()) return toast.error("Add a title and a message.");
    try { await api.post("/host/announcements", { title, message }); setTitle(""); setMessage(""); toast.success("Announcement posted."); refresh(); }
    catch (e) { toast.error(friendlyError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/host/announcements/${id}`); refresh(); } catch (e) { toast.error(friendlyError(e)); } };

  return (
    <div className="space-y-6 animate-fade-in max-w-2xl">
      <div><h1 className="font-serif text-3xl text-espresso">Announcements</h1><p className="text-inkSoft mt-1">Post updates guests see on the invitation.</p></div>
      <div className="rounded-3xl bg-white border border-hair shadow-soft p-6 space-y-3">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title (e.g. Parking info added)" className="w-full bg-cream2/50 border border-hair rounded-xl px-4 py-3 focus:border-gold outline-none" data-testid="ann-title" />
        <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message…" rows={3} className="w-full bg-cream2/50 border border-hair rounded-xl px-4 py-3 focus:border-gold outline-none" data-testid="ann-message" />
        <button onClick={post} className="flex items-center gap-2 gold-gradient text-espressoDeep font-bold px-6 py-3 rounded-full shadow-gold active:scale-95 transition" data-testid="ann-post"><Plus size={18} /> Post Update</button>
      </div>
      <div className="space-y-3">
        {items.length === 0 && <p className="text-inkSoft text-sm">No announcements yet.</p>}
        {items.map((a) => (
          <div key={a.id} className="rounded-2xl bg-white border border-hair p-5 flex items-start justify-between gap-4" data-testid={`ann-${a.id}`}>
            <div className="flex items-start gap-3">
              <Megaphone size={18} className="text-gold mt-1 shrink-0" />
              <div><p className="font-serif text-lg text-espresso">{a.title}</p><p className="text-inkSoft text-sm mt-0.5">{a.message}</p><p className="text-xs text-inkMuted mt-2">{new Date(a.published_at).toLocaleString()}</p></div>
            </div>
            <button onClick={() => del(a.id)} className="p-2 rounded-lg hover:bg-[#D97706]/10 text-[#D97706]" data-testid={`ann-del-${a.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
